<template>
  <div>
    <vessel-trial-test-details
      class="mb-2"
      v-for="test in tests"
      :key="test.vesselTrialTestId"
      :vessel-trial-test="test"
    ></vessel-trial-test-details>
  </div>
</template>

<script>
import VesselTrialTestDetails from '@/components/VesselTrialTestDetails.vue'
import ApiService from '@/services/ApiService.js'
import ObjectType from '@/services/Objects.js'

export default {
  name: 'PdfTrialExport',
  components: {
    VesselTrialTestDetails
  },
  props: {
    id: String
  },
  data() {
    return {
      tests: []
    }
  },
  created() {
    this.getTests()
  },
  methods: {
    getTests() {
      ApiService.get(ObjectType.VesselTrialTest + '/bytrial', this.id).then(
        response => {
          this.tests = response.data
        }
      )
    }
  }
}
</script>

<style scoped></style>
